import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp8};
  flex-wrap: wrap;

  & > div {
    max-width: calc(50% - ${props => props.theme.spacing.sp32});
    label {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
`
